import React from 'react';
import styled from 'styled-components';
import { useEditMode } from '../../../shared/hooks/useEditMode';
import { useProjectElementListStore } from '../../../shared/store/projectElementStore';
import { getAlignment } from '../../../shared/component/headless/textarea/TextAreaBody';
import { TextBoxData } from '../../../shared/dto/EntityRepository';
import { TextAlignment } from '../../../shared/enum/EnumRepository';
import { PEHeader, PEIndicator } from './WorkMobile';
import ConstrainedRichText from '../../../shared/richText/ConstrainedRichText';
import { TEXTBOX_CONTENT_MAX_LENGTH } from '../../../shared/constants/limits';


export interface TextBoxProps {
  peId: string;
  data: TextBoxData;
}

const TextBox: React.FC<TextBoxProps> = ({ peId, data }) => {
  const { isEditMode } = useEditMode();
  const handleChange = useProjectElementListStore((s) => s.updateTextBox);

  return (
    <TextBoxWrapper>
      {isEditMode &&
      <PEHeader>
        <PEIndicator peId={peId}>: TextBox</PEIndicator>
      </PEHeader>
      }
      <TextBoxContentWrapper>
        <TextBoxColumn $isEditMode={isEditMode}>
          <ConstrainedRichText
            value={data.content}
            onChange={(next) => handleChange(peId, { content: next })}
            StyledView={TextBoxContent}
            maxLength={TEXTBOX_CONTENT_MAX_LENGTH}
            maxRows={100}
          />
        </TextBoxColumn>
      </TextBoxContentWrapper>
    </TextBoxWrapper>
  );
}

export const TextBoxWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 80px;
`;

const TextBoxContentWrapper = styled.div`
  padding: 0 clamp(18px, 5vw, 24px);
  --rich-text-size-s: ${({ theme }) => theme.fontSize.font_B04};
  --rich-text-size-l: ${({ theme }) => theme.fontSize.font_B02};
`;

const TextBoxColumn = styled.div<{ $isEditMode: boolean }>`
  width: 100%;
  border-bottom: ${({ $isEditMode, theme }) => $isEditMode ? `1px solid ${theme.colors.color_Gray_05}` : 'none'};
`;

const TextBoxContent = styled.div<{ $alignment: TextAlignment }>`
  padding: 12px 0 4px 0;
  overflow-wrap: break-word;
  word-break: break-word;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  text-align: ${({ $alignment }) => getAlignment($alignment)};
  ${({ theme }) => theme.typography.Body_03_2};
  line-height: 1;
`;

export default TextBox;
